import { render, staticRenderFns } from "./RsaPazientePaiDomiciliareListComponent.vue?vue&type=template&id=02f39453&scoped=true"
import script from "./RsaPazientePaiDomiciliareListComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePaiDomiciliareListComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazientePaiDomiciliareListComponent.vue?vue&type=style&index=0&id=02f39453&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f39453",
  null
  
)

export default component.exports